// SlidingTextAnimation.js
import React from 'react';
import '../animation_json/textAnimation.css';

const SlidingTextAnimation = () => {
    return (
        <div className="slider-container">
            <span className="slider-text">
                UI/UX engineer designs <span style={{ color: 'red' }}>intuitive</span> digital experiences, develops frontends, ensures
                <span style={{ color: 'red' }}> accessibility</span>,
                and iterates based on user <span style={{ color: 'red' }}>feedback</span>
            </span>
            {/* Duplicate the text for seamless looping */}
            <span className="slider-text">
                UI/UX engineer designs <span style={{ color: 'red' }}>intuitive</span> digital experiences, develops frontends, ensures
                <span style={{ color: 'red' }}> accessibility</span>,
                and iterates based on user <span style={{ color: 'red' }}>feedback</span>
            </span>
        </div>
    );
}

export default SlidingTextAnimation;
